import {
  NgxMatDateFormats,
  NGX_MAT_NATIVE_DATE_FORMATS,
} from '@angular-material-components/datetime-picker';
import { Injectable } from '@angular/core';
import { ObjectUtils } from '../../utils/object.utils';

const dateFormat = { year: 'numeric', month: 'numeric', day: 'numeric' };

@Injectable()
export class DateFormats {
  showTimeFormat = true;

  parse = NGX_MAT_NATIVE_DATE_FORMATS['parse'];

  display: NgxMatDateFormats['display'] = new Proxy(
    ObjectUtils.clone(NGX_MAT_NATIVE_DATE_FORMATS.display),
    {
      get: (target, key) => {
        let value: any;
        if (key === 'dateInput') {
          if (!this.showTimeFormat) {
            value = dateFormat;
          }
        }

        if (!value) {
          value = target[key];
        }

        return value;
      },
    }
  ) as any;
}
